import { Component, Inject } from '@angular/core';

@Component({
    selector: 'app-urlscomponent',
    templateUrl: './url.component.html',
    standalone: false
})
export class UrlsComponent {
	public url = '';

	constructor(@Inject('UrlService') public urlService: any) {}

	formatUrl(theMappedUrl: string) {
		if (theMappedUrl.indexOf('http://') === 0 || theMappedUrl.indexOf('https://') === 0) {
			return theMappedUrl;
		}

		return this.url + theMappedUrl;
	}

	getFaq() {
		const faqLink = this.urlService.faq(this.url);
		window.open(faqLink, '_blank');
	}
}
